const toggleMobileMenu = () => {
  const $header = $('.header')
  const $headerLogo = $('.header__logo')
  const $headerNav = $('.header__nav')
  const $headerLinkAcc = $('.header__link_acc')
  const $headerWrapper = $('.header__wrapper')
  const $burgerMenu = $('.header__burger')
  const $headerOverlay = $('.header__overlay')
  const $headerItems = $('.header__items')

  $burgerMenu.on('click', function() {
    $(this).toggleClass('active')
    $header.toggleClass('active h-100 rounded-0')
    $headerLogo.toggleClass('active')
    $headerNav.toggleClass('active')
    $headerWrapper.find('.header__link_acc').toggleClass('active')
    $headerWrapper.parent().toggleClass('pt-0')

    if ($burgerMenu.hasClass('active')) {
      $headerOverlay.removeClass('d-none').addClass('d-block')
      $headerItems.removeClass('d-none').addClass('d-flex')
      $headerWrapper.addClass('px-0 h-100')
      document.body.style.overflow = 'hidden'
    } else {
      $headerOverlay.removeClass('d-block').addClass('d-none')
      $headerItems.removeClass('d-flex').addClass('d-none')
      $headerWrapper.removeClass('px-0 h-100')
      document.body.style.overflow = 'auto'
    }
  })

  $(window).on('resize', () => {
    if (window.innerWidth > 992) {
      $header.removeClass('active h-100 rounded-0')
      $headerWrapper.removeClass('px-0 h-100')
      $headerLogo.removeClass('active')
      $headerNav.removeClass('active')
      $headerLinkAcc.removeClass('active')
      $headerWrapper.parent().removeClass('pt-0')
      document.body.style.overflow = 'auto'
    } else if ($burgerMenu.hasClass('active')) {
      $header.addClass('active h-100 rounded-0')
      $headerWrapper.addClass('px-0 h-100')
      $headerLogo.addClass('active')
      $headerNav.addClass('active')
      $headerLinkAcc.addClass('active')
      $headerWrapper.parent().addClass('pt-0')
      document.body.style.overflow = 'hidden'
    }
  })
}

export default toggleMobileMenu